import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as itemsActions from 'store/modules/items';

import ItemDetailWeapon from 'components/items/ItemDetailWeapon';

import { weaponSkillList } from 'util/damageCalc';

class ItemDetailWeaponContainer extends Component {
  
  componentDidMount() {
    
  }

  ctrlWeaponUp = (e) => {
    const {ItemsActions, currSelWeapon} = this.props;
    const {optionView} = currSelWeapon.currItemOption;
    const currSel = 'currSelWeapon';
    const gubun = optionView === e.target.value ? '' : e.target.value;
    ItemsActions.setItemDetailOption({currSel, gubun});
  }

  setBodyup = (cnt) => {
    const {ItemsActions} = this.props;
    const currSel = 'currSelWeapon';
    ItemsActions.setBodyup({currSel, cnt});
  }

  setPowerup = (cnt) => {
    const {ItemsActions,} = this.props;
    const currSel = 'currSelWeapon';
    ItemsActions.setPowerup({currSel, cnt});
  }

  render() {
    const {/*popupClose, */ctrlWeaponUp, setBodyup, setPowerup} = this;
    const {currSelWeapon} = this.props;
    
    return (
      <ItemDetailWeapon 
      // popupClose={popupClose}
      currSelWeapon={currSelWeapon}
      ctrlWeaponUp={ctrlWeaponUp}
      setBodyup={setBodyup}
      setPowerup={setPowerup}
      />
    );
  }
}

export default connect(
  (state) => ({
    currSelWeapon: state.items.toJS().currSelWeapon,
    itemList: state.items.toJS().itemList
  }),
  (dispatch) => ({
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(ItemDetailWeaponContainer);